import React from 'react';
import { AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';
import { getProbabilityInfo } from '../../api/claims';

const ProbabilityBadge = ({ probability, size = 'md', showIcon = true }) => {
  const info = getProbabilityInfo(probability);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSize = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const icons = {
    low: CheckCircle,
    medium: AlertTriangle,
    high: AlertCircle
  };

  const Icon = icons[probability] || AlertTriangle;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${info.bgColor} ${info.textColor} ${sizeClasses[size]}`}
    >
      {showIcon && <Icon className={iconSize[size]} />}
      <span>{info.label}</span>
    </span>
  );
};

export const ProbabilitySelector = ({ value, onChange, disabled = false }) => {
  const probabilities = ['low', 'medium', 'high'];
  const icons = {
    low: CheckCircle,
    medium: AlertTriangle,
    high: AlertCircle
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Probability of Success
      </label>
      <div className="flex gap-2">
        {probabilities.map(prob => {
          const info = getProbabilityInfo(prob);
          const isSelected = value === prob;
          const Icon = icons[prob];

          return (
            <button
              key={prob}
              type="button"
              disabled={disabled}
              onClick={() => onChange(prob)}
              className={`flex-1 px-4 py-2 rounded-lg font-medium transition-all ${
                isSelected
                  ? `${info.bgColor} ${info.textColor} ring-2 ring-offset-2 ring-${info.color}-400`
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <div className="flex items-center justify-center gap-2">
                <Icon className="h-5 w-5" />
                <span>{info.label}</span>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-gray-500">
        Select the likelihood of this claim being successfully resolved
      </p>
    </div>
  );
};

export default ProbabilityBadge;
